module.exports = __webpack_public_path__ + "MuseoSans-500Italic.2927c18a336e3f670f06.svg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500Italic.svg
// module id = ../../../../../src/assets/fonts/MuseoSans-500Italic.svg
// module chunks = styles